import React from 'react';

type LegalPageLayoutProps = {
  title: string;
  meta?: string;
  children: React.ReactNode;
};

export function LegalPageLayout({ title, meta, children }: LegalPageLayoutProps) {
  return (
    <div className="s-wrap" style={{ maxWidth: 860 }}>
      <p className="s-eyebrow">Legal</p>
      <h1 className="s-h2" style={{ marginBottom: 8 }}>{title}</h1>
      {meta ? <p className="terms-meta">{meta}</p> : null}
      <div className="terms-body">{children}</div>
    </div>
  );
}

export function LegalSection({ id, title, children }: { id?: string; title: string; children: React.ReactNode }) {
  return (
    <section className="terms-section" id={id}>
      <h2 className="terms-h2">{title}</h2>
      {children}
    </section>
  );
}

export function LegalSubheading({ children }: { children: React.ReactNode }) {
  return <h3 className="terms-h3">{children}</h3>;
}

export function LegalSubheadingSm({ children }: { children: React.ReactNode }) {
  return <h4 className="terms-h4">{children}</h4>;
}
